module.exports = __webpack_public_path__ + "static/img/page_20.9c8c8bae.png";